<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>用户心情</span>
        </div>

        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="用户ID" prop="uid">
            <el-select v-model="queryParams.uid" placeholder="请选择">
              <el-option
                v-for="item in userList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="exportMoods">导出心情</el-button>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="exportRate">导出概率</el-button>
          </el-form-item>
        </el-form>

        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="uid"
            label="用户ID"
          />
          <el-table-column
            prop="type"
            label="事件类型"
            :formatter="typeFormatter"
          />
          <el-table-column
            prop="num"
            label="次数"
          />
          <el-table-column
            prop="score"
            label="心情得分"
          />
        </el-table>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
      <el-card>
        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>触发次数</span>
        </div>

        <el-table
          :data="tableRateData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="pos"
            label="格子"
          />
          <el-table-column
            prop="type"
            label="事件类型"
            :formatter="typeFormatter"
          />
          <el-table-column
            prop="count"
            label="触发次数"
          />
          <el-table-column
            prop="rate"
            label="触发概率"
            :formatter="rateFormatter"
          />
        </el-table>
      </el-card>

    </template>
  </BasicLayout>
</template>

<script>
import echarts from 'echarts'
import {
  exportSlotTestMoods,
  exportSlotTestRate,
  getSlotTestMoodsList,
  getSlotTestUserList
} from '@/api/config/slot-test'
import { getChessBoardType } from '@/api/config/slot'

export default {
  name: 'SlotTestStat',
  data() {
    return {
      id: 0,
      total: 0,
      chartData: {},
      queryParams: {
        pageIndex: 1,
        pageSize: 50,
        id: 0,
        uid: 0
      },
      loading: false,
      options: [],
      tableData: [],
      tableRateData: [],
      date: [],
      chart: {},
      option: {},
      chessBoardType: [],
      userList: []
    }
  },
  created() {
    this.getChessType()
    this.id = this.$route.query.id
    this.getUserList()
    this.getTables()
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleQuery() {
      this.getTables()
    },
    getUserList() {
      getSlotTestUserList({ id: this.id }).then(res => {
        if (res.code === 200) {
          res.data.forEach(res => {
            this.userList.push({ label: res.uid, value: res.uid })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      this.queryParams.id = this.id
      getSlotTestMoodsList(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.list.moods
          this.tableRateData = res.data.list.rate
          this.total = res.data.count
          const data = []
          this.date = []
          res.data.list.moods.forEach(item => {
            this.date.push(item.num)
            // this.date.push(this.typeFormatter(0, 0, item.type))
            data.push(item.score)
          })

          this.option.xAxis.data = this.date
          this.option.series[0].data = data
          this.chart.setOption(this.option)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getChessType() {
      getChessBoardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.chessBoardType.push({ 'title': res.data[i], 'id': parseInt(i) })
          }
        }
      })
    },
    numFormatter(row, column, cellValue, index) {
      return cellValue + '%'
    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: '用户心情曲线'
        },
        xAxis: {
          name: '类型',
          type: 'category',
          data: [],
          axisLabel: {
            interval: 0 // 这个属性设置了每个标签都要显示
          }
        },
        legend: {
          data: [
            '偷/打', '骰子点数', '金币1', '金币2', '金币3', '金币4',
            '金币5', '金币6', '金币7', '金币8', '起点收入', '所得税',
            '巨额税款', '随机卡', '社会基金', '飞艇', '免费商店', '灯泡',
            '水管'
          ]
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}/分' // 使用默认的数值格式
          }
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: { readOnly: false },
            magicType: { type: ['line', 'bar'] },
            // restore: {},
            saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '心情',
            data: [],
            type: 'line',
            markPoint: {
              data: [
                { type: 'max', name: 'Max' },
                { type: 'min', name: 'Min' }
              ]
            },
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}分' // 显示数值
            }
          }
        ]
      }
      this.chart.setOption(this.option)
    },
    typeFormatter(col, row, v) {
      let text = ''
      for (const i in this.chessBoardType) {
        const val = this.chessBoardType[i]
        if (val.id === v) {
          text = val.title
          break
        }
      }
      return text
    },
    rateFormatter(col, row, v) {
      return v + '%'
    },
    exportMoods() {
      exportSlotTestMoods({ id: this.id }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportRate() {
      exportSlotTestRate({ id: this.id }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
